import { render, staticRenderFns } from "./knowledgeCategoryList.vue?vue&type=template&id=1301e3d8"
import script from "./knowledgeCategoryList.vue?vue&type=script&lang=js"
export * from "./knowledgeCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports